export const AppConfig = {
  MORPHOLOGY_LANGUAGE: 'english'
}
